import moment from 'moment';

const allOption = { label: 'All', value: 'all' };

export function columns() {
  return [{
    id: 1, title: 'Date and time', field: 'timestamp', filter: '', filterMinWidth: 60,
    getValue: rowData => getFormatDateTime(rowData.time)
  }, {
    id: 2, title: 'Type', field: 'message_type', filter: 'all', filterType: 'select', filterMinWidth: 50,
    options: [allOption, { label: 'Event', value: 'event' }, { label: 'Metric', value: 'metric' }]
  }, {
    id: 3, title: 'Component', field: 'component', filter: 'all', filterType: 'select', filterMinWidth: 80,
    options: [allOption, { label: 'EWC', value: 'EWC' }, { label: 'EWM', value: 'EWM' }, { label: 'EWV', value: 'EWV' }]
  }, {
    id: 4, title: 'Component ID', field: 'component_id', filter: '', filterLabel: 'Filter By Component ID', filterMinWidth: 100
  }, {
    id: 5, title: 'Subcomponent', field: 'sub_component', filter: 'all', filterType: 'select', filterMinWidth: 95,
    options: [allOption, { label: 'VCAM', value: 'VCAM' }, { label: 'PCAM', value: 'PCAM' }, { label: 'SPTS', value: 'SPTS' }]
  }, {
    id: 6, title: 'Subcomponent ID', field: 'sub_component_id', filter: '', filterLabel: 'Filter By Subcomponent ID', filterMinWidth: 190
  }, {
    id: 7, title: 'Subject', field: 'subject', filter: '', filterLabel: 'Filter By Message', filterMinWidth: 105
  }]
}

function getFormatDateTime(timestamp) {
  const dateFormat = 'YYYY-MM-DD HH:mm';
  const isNotEmpty = timestamp !== undefined && timestamp !== null && timestamp !== '';
  return isNotEmpty ? moment(timestamp).format(dateFormat) : '-';
}
